import { ContactSupportOutlined } from '@mui/icons-material';
import { Box, Button, Card, Container, Dialog, DialogActions, DialogContent, DialogTitle, duration, Input, InputBase, MenuItem, Paper, Popover, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify';
import { getData, postData, uploadFile } from 'src/webService/webService';

function OnGoingTasks() {

    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType")
    const UserId = sessionStorage.getItem('userId')
    const [isWorkStarted, setIsWorkStarted] = useState(false);
    const [fileUpload, setFileUpload] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);
    const [formOpen, setFormOpen] = useState(null);

    const [getServiceData, setGetServiceData] = useState([]);

    const sessionToken = sessionStorage.getItem("Token");

    const [selectedFiles, setSelectedFiles] = useState({});

    const [leadData, setLeadData] = useState({})

    const [formData, setFormData] = useState({
        // For Graphic Designing
        fileFormat: '',
        status: '',
        comments: '',
        fileUpload: '',
        completionPercentage: '',
        completedDesigns: '',
        // For WebSite Designing
        completedPages: '',
        requirements: '',
        progressPercentage: '',
        contentStatus: '',
        seoOptimizationStatus: '',
        designApproval: '',
        //For Content Creation
        keywords: '',
        seoFocus: '',
        wordCount: '',
        status: '',
        fileUpload: '',
        completionStatus: '',
        completedTasks: '',
        //For Camera Man
        completionStatus: "",
        fileUpload: "",
        //For Video Editing
        rawFootageUpload: "",
        editingSoftwareUsed: "",
        editingProgress: "",
        comments: "",
        teamCommunicationNotes: "",
        //For Social Media
        postStatus: "",
        contentTopic: "",
        comments: "",
        scheduledDateTime: "",
        deadline: "",
    })

    useEffect(() => {
        if (serviceTeamType === "WebSite Designing") {
            setLeadData({
                leadId: '',
                userId: '',
                websiteType: '',
                totalPages: '',
                duration: '',
                clientName: '',
                deadline: ''
            });

            setFormData({
                completedPages: '',
                requirements: '',
                fileUpload: fileUpload,
                progressPercentage: '',
                contentStatus: '',
                seoOptimizationStatus: '',
                designApproval: '',
                comments: '',
            });
        } else if (serviceTeamType === "Graphic Designing") {
            setLeadData({
                leadId: '',
                userId: '',
                projectName: '',
                clientName: '',
                designType: '',
                requirements: '',
                deadline: '',
                totalDesigns: '',
                serviceName: ''
            });

            setFormData({
                fileFormat: '',
                status: '',
                comments: '',
                fileUpload: fileUpload,
                completionPercentage: '',
                completedDesigns: ''
            });
        } else if (serviceTeamType === "Content Creation") {
            setLeadData({
                leadId: "",
                userId: "",
                projectName: "",
                contentType: "",
                targetAudience: "",
                deadline: "",
                comments: "",
                totalTasks: "",
                serviceName: "",
            });

            setFormData({
                keywords: '',
                seoFocus: '',
                wordCount: '',
                status: '',
                fileUpload: fileUpload,
                completionStatus: '',
                completedTasks: '',
            });
        } else if (serviceTeamType === "Camera Man") {
            setLeadData({
                leadId: "",
                userId: "",
                projectName: "",
                shootType: "",
                location: "",
                scheduledDateTime: "",
                shotList: "",
                clientGuidelines: "",
                comments: "",
                deadline: "",
                serviceName: "",
            });
            setFormData({
                completionStatus: "",
                rawFootageUpload: fileUpload,
            });
        } else if (serviceTeamType === "Video Editing") {
            setLeadData({
                leadId: "",
                userId: "",
                projectName: "",
                deadline: "",
                serviceName: "",
            });
            setFormData({
                rawFootageUpload: "",
                editingSoftwareUsed: "",
                editingProgress: "",
                comments: "",
                teamCommunicationNotes: "",
            })
        } else if (serviceTeamType === "Social Media") {
            setLeadData({
                leadId: "",
                userId: "",
                platform: "",
                postType: "",
                hashtagsUsed: "",
                postedBy: "",
                postStatus: "",
                serviceName: "",
            });
            setFormData({
                postStatus: "",
                contentTopic: "",
                comments: "",
                scheduledDateTime: "",
                deadline: "",
            })
        }
    }, [serviceTeamType]);


    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const headersByTeam = {
        "Camera Man": ["S.No", "Lead Name", "Contact", "Shoot Type", "Location", "Scheduled", "Deadline"],
        "Graphic Designing": ["S.No", "Lead Name", "Phone", "Design Type", "Total Designs", "Requirements", "Deadline"],
        "Video Editing": ["S.No", "Name", "Phone", "Editing Type", "Software", "Comments", "Deadline"],
        "Content Creation": ["S.No", "Name", "Phone", "Content Type", "Target Audience", "Comments", "Deadline"],
        "WebSite Designing": ["S.No", "Name", "Phone", "Website Type", "Total Pages", "Requirements", "Deadline"],
        "Social Media": ["S.No", "Name", "Phone", "Platform", "Post Type", "Content Topic", "Deadline"],
        "SEO": ["S.No", "Name", "Phone", "Shoot Type", "Location", "Scheduled Date", "Deadline"],
    };

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = (id) => {
        setAnchorEl(null);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const getDataByServiceTeam = async () => {
        try {

            const response = await getData(`leads/leads/${UserId}`, {}, sessionToken);
            console.log("Response getdata:", response);

            const results = response?.data?.[0]?.paginatedResults;
            console.log("Results:", results);
            const data = results?.[0];

            const serviceName = data?.serviceHistory?.[0]?.serviceName?.[0];

            const serviceMap = {
                "WebSite Designing": {
                    leadId: data?.websiteDesigningHistory[0]?.leadId,
                    userId: data?.websiteDesigningHistory[0]?.assignedTo,
                    websiteType: data?.websiteDesigningHistory[0]?.websiteType,
                    totalPages: data?.websiteDesigningHistory[0]?.totalPages,
                    duration: data?.websiteDesigningHistory[0]?.duration,
                    leadName: data?.websiteDesigningHistory[0]?.clientName,
                    deadline: data?.websiteDesigningHistory[0]?.deadline,
                    serviceName,
                },
                "Graphic Designing": {
                    leadId: data?.graphicDesignHistory[0]?.leadId,
                    userId: data?.graphicDesignHistory[0]?.assignedTo,
                    projectName: data?.graphicDesignHistory[0]?.requirements,
                    clientName: data?.graphicDesignHistory[0]?.clientName,
                    designType: data?.graphicDesignHistory[0]?.designType,
                    requirements: data?.graphicDesignHistory[0]?.requirements,
                    deadline: data?.graphicDesignHistory[0]?.deadline,
                    totalDesigns: data?.graphicDesignHistory[0]?.totalDesigns,
                    serviceName,
                },
                "Content Creation": {
                    leadId: data?.contentCreationHistory[0]?.leadId,
                    userId: data?.contentCreationHistory[0]?.assignedTo,
                    projectName: data?.contentCreationHistory[0]?.requirements,
                    contentType: data?.contentCreationHistory[0]?.contentType,
                    targetAudience: data?.contentCreationHistory[0]?.targetAudience,
                    deadline: data?.contentCreationHistory[0]?.deadline,
                    comments: data?.contentCreationHistory[0]?.comments,
                    totalTasks: data?.contentCreationHistory[0]?.totalTasks,
                    serviceName,
                },
                "Camera Man": {
                    leadId: data?.cameraHistory[0]?.leadId,
                    userId: data?.cameraHistory[0]?.assignedTo,
                    projectName: data?.cameraHistory[0]?.location,
                    shootType: data?.cameraHistory[0]?.shootType,
                    location: data?.cameraHistory[0]?.location,
                    scheduledDateTime: data?.cameraHistory[0]?.scheduledDateTime,
                    shotList: data?.cameraHistory[0]?.shotList,
                    clientGuidelines: data?.cameraHistory[0]?.clientGuidelines,
                    comments: data?.cameraHistory[0]?.comments,
                    deadline: data?.cameraHistory[0]?.deadline,
                    serviceName,
                },
                "Video Editing": {
                    leadId: data?.videoEditingHistory[0]?.leadId,
                    userId: data?.videoEditingHistory[0]?.assignedTo,
                    projectName: data?.videoEditingHistory[0]?.editingType,
                    deadline: data?.videoEditingHistory[0]?.deadline,
                    serviceName,
                },
                "Social Media": {
                    leadId: data?.socialMediaHistory[0]?.leadId,
                    userId: data?.socialMediaHistory[0]?.assignedTo,
                    platform: data?.socialMediaHistory[0]?.platform,
                    postType: data?.socialMediaHistory[0]?.postType,
                    hashtagsUsed: data?.socialMediaHistory[0]?.hashtagsUsed[0],
                    postedBy: data?.socialMediaHistory[0]?.assignedTo,
                    postStatus: data?.socialMediaHistory[0]?.postStatus,
                    serviceName,
                }
            };

            if (serviceMap[serviceTeamType]) {
                setLeadData(serviceMap[serviceTeamType]);
                console.log("leadData set:", serviceMap[serviceTeamType]);
            }

            setGetServiceData(results);

        } catch (err) {
            console.error("Error while fetching Tasks:", err);
            toast.error("Failed to load Tasks.");
        }
    }

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File); // should be true

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${leadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!");
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error("Error uploading file.");
        }
    };

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            fileupload: fileUpload || '',
        }));
    }, [fileUpload]);

    const postDailyUpdates = async () => {
        console.log("Form Data:", formData);
        console.log("Lead Data:", leadData);

        try {

            const combinedData = {
                ...formData,
                ...leadData
            };

            const response = await postData("dailyworkupdates", combinedData, sessionToken);

            if (response?.status === 200) {
                console.log("Response:", response);
                setFormOpen(false);
                setIsWorkStarted(true);
                toast.success("Daily Work Updated Successfully!");

            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong. Please try again!");
        }

    }

    useEffect(() => {
        getDataByServiceTeam();
        console.log("Lead Data:", leadData);
    }, []);

    return (
        <>
            <Helmet>
                <title>{`${role} - ${roleType} | ${serviceTeamType}`}</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Total Projects
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {headersByTeam[serviceTeamType]?.map((header, i) => (
                                        <TableCell key={i}>{header}</TableCell>
                                    ))}
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getServiceData.map((service, index) => (
                                    <TableRow key={service?._id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{service?.name}</TableCell>
                                        <TableCell>{service?.phone}</TableCell>

                                        {serviceTeamType === "Graphic Designing" && (
                                            <>
                                                <TableCell>{service?.graphicDesignHistory?.designType}</TableCell>
                                                <TableCell>{service?.graphicDesignHistory?.totalDesigns}</TableCell>
                                                <TableCell>{service?.graphicDesignHistory?.requirements}</TableCell>
                                                <TableCell>
                                                    {service?.graphicDesignHistory?.deadline
                                                        ? new Date(service?.graphicDesignHistory?.deadline).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {!isWorkStarted && (
                                                        <Iconify icon="material-symbols-light:more-vert" sx={{ margin: "auto", cursor: "pointer" }} onClick={(event) => handleOpenMenu(event)} />
                                                    )}
                                                </TableCell>
                                            </>
                                        )}

                                        {serviceTeamType === "Camera Man" && (
                                            <>
                                                <TableCell>{service?.cameraHistory?.shootType}</TableCell>
                                                <TableCell>{service?.cameraHistory?.location}</TableCell>
                                                <TableCell>
                                                    {service?.cameraHistory?.scheduledDateTime
                                                        ? new Date(service?.cameraHistory?.scheduledDateTime).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {service?.cameraHistory?.deadline
                                                        ? new Date(service?.cameraHistory?.deadline).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {!isWorkStarted && (
                                                        <Iconify icon="material-symbols-light:more-vert" sx={{ margin: "auto", cursor: "pointer" }} onClick={(event) => handleOpenMenu(event)} />
                                                    )}
                                                </TableCell>
                                            </>
                                        )}

                                        {serviceTeamType === "Video Editing" && (
                                            <>
                                                <TableCell>{service?.videoEditingHistory?.editingType}</TableCell>
                                                <TableCell>{service?.videoEditingHistory?.editingSoftwareUsed}</TableCell>
                                                <TableCell>{service?.videoEditingHistory?.comments ? service?.videoEditingHistory?.comments : "-"}</TableCell>
                                                <TableCell>
                                                    {service?.videoEditingHistory?.deadline
                                                        ? new Date(service?.videoEditingHistory?.deadline).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {!isWorkStarted && (
                                                        <Iconify icon="material-symbols-light:more-vert" sx={{ margin: "auto", cursor: "pointer" }} onClick={(event) => handleOpenMenu(event)} />
                                                    )}
                                                </TableCell>
                                            </>
                                        )}

                                        {serviceTeamType === "Content Creation" && (
                                            <>
                                                <TableCell>{service?.contentCreationHistory?.contentType}</TableCell>
                                                <TableCell>{service?.contentCreationHistory?.targetAudience}</TableCell>
                                                <TableCell>{service?.contentCreationHistory?.comments ? service?.contentCreationHistory?.comments : "-"}</TableCell>
                                                <TableCell>
                                                    {service?.contentCreationHistory?.deadline
                                                        ? new Date(service?.contentCreationHistory?.deadline).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {!isWorkStarted && (
                                                        <Iconify icon="material-symbols-light:more-vert" sx={{ margin: "auto", cursor: "pointer" }} onClick={(event) => handleOpenMenu(event)} />
                                                    )}
                                                </TableCell>
                                            </>
                                        )}

                                        {serviceTeamType === "WebSite Designing" && (
                                            <>
                                                <TableCell>{service?.websiteDesigningHistory?.websiteType}</TableCell>
                                                <TableCell>{service?.websiteDesigningHistory?.totalPages}</TableCell>
                                                <TableCell>{service?.websiteDesigningHistory?.requirements ? service?.websiteDesigningHistory?.requirements : "-"}</TableCell>
                                                <TableCell>
                                                    {service?.websiteDesigningHistory?.deadline
                                                        ? new Date(service?.websiteDesigningHistory?.deadline).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {!isWorkStarted && (
                                                        <Iconify icon="material-symbols-light:more-vert" sx={{ margin: "auto", cursor: "pointer" }} onClick={(event) => handleOpenMenu(event)} />
                                                    )}
                                                </TableCell>
                                            </>
                                        )}

                                        {serviceTeamType === "Social Media" && (
                                            <>
                                                <TableCell>{service?.socialMediaHistory[0]?.platform}</TableCell>
                                                <TableCell>{service?.socialMediaHistory[0]?.postType}</TableCell>
                                                <TableCell>{service?.socialMediaHistory[0]?.contentTopic ? service?.socialMediaHistory[0]?.contentTopic : "-"}</TableCell>
                                                <TableCell>
                                                    {service?.socialMediaHistory[0]?.deadline
                                                        ? new Date(service?.socialMediaHistory[0]?.deadline).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'}
                                                </TableCell>
                                                <TableCell>
                                                    {!isWorkStarted && (
                                                        <Iconify icon="material-symbols-light:more-vert" sx={{ margin: "auto", cursor: "pointer" }} onClick={(event) => handleOpenMenu(event)} />
                                                    )}
                                                </TableCell>
                                            </>
                                        )}

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>

                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    <MenuItem onClick={() => { setFormOpen(true); handleCloseMenu() }}>
                        <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                        Start Work
                    </MenuItem>
                </Popover>

                <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
                    <DialogTitle>Work Update</DialogTitle>

                    {serviceTeamType === "WebSite Designing" && (
                        <>
                            <DialogContent>
                                <TextField margin="dense" label="Completed Pages" name="completedPages" value={formData.completedPages} onChange={handleChange} type="number" fullWidth />
                                <TextField margin="dense" label="Requirements" name="requirements" value={formData.requirements} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Progress Percentage" name="progressPercentage" value={formData.progressPercentage} onChange={handleChange} type="number" fullWidth />
                                <TextField margin="dense" select label="Status" name="status" value={formData.status || ''} onChange={handleChange} fullWidth>
                                    {["Pending", "In Progress", "Completed"].map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField margin="dense" select label="Content Status" name="contentStatus" value={formData.contentStatus || ''} onChange={handleChange} fullWidth>
                                    {["Pending", "In Progress", "Completed"].map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField margin="dense" select label="SEO Optimization Status" name="seoOptimizationStatus" InputLabelProps={{ shrink: true }} value={formData.seoOptimizationStatus} onChange={handleChange} fullWidth>
                                    <MenuItem value={true}>True</MenuItem>
                                    <MenuItem value={false}>False</MenuItem>
                                </TextField>
                                <TextField margin="dense" select label="Design Approval" name="designApproval" type='boolean' InputLabelProps={{ shrink: true }} value={formData.designApproval} onChange={handleChange} fullWidth>
                                    <MenuItem value={true}>True</MenuItem>
                                    <MenuItem value={false}>False</MenuItem>
                                </TextField>
                                <TextField margin="dense" label="Comments" name="comments" InputLabelProps={{ shrink: true }} value={formData.comments} onChange={handleChange} fullWidth />
                                <Input
                                    type="file"
                                    name="fileupload"
                                    accept=".jpg,.jpeg,.png,.webp,.avif,"
                                    onChange={(e) => handleFileChange(e, UserId)}
                                />
                                {selectedFiles[UserId] && <span>{selectedFiles[UserId].name}</span>}
                            </DialogContent>
                        </>
                    )}

                    {serviceTeamType === "Graphic Designing" && (
                        <>
                            <DialogContent>
                                <TextField margin="dense" select label="status" name="status" value={formData.status || ''} onChange={handleChange} fullWidth>
                                    {["Pending", "In Progress", "Completed"].map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField margin="dense" select label="Format" name="fileFormat" value={formData.fileFormat || ''} onChange={handleChange} fullWidth>
                                    {["PNG", "PSG", "AI", "PDF"].map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField margin="dense" label="Completed Design" name="completedDesigns" value={formData.completedDesigns} onChange={handleChange} type="number" fullWidth />
                                <TextField margin="dense" label="Completed Percentage" name="completionPercentage" value={formData.completionPercentage} onChange={handleChange} type="number" fullWidth />
                                <TextField margin="dense" label="Comments" name="comments" InputLabelProps={{ shrink: true }} value={formData.comments} onChange={handleChange} fullWidth />
                                <Input
                                    type="file"
                                    name="fileUpload"
                                    accept=".jpg,.jpeg,.png,.webp,.avif,"
                                    onChange={(e) => handleFileChange(e, UserId)}
                                />
                                {selectedFiles[UserId] && <span>{selectedFiles[UserId].name}</span>}
                            </DialogContent>
                        </>
                    )}

                    {serviceTeamType === "Content Creation" && (
                        <>
                            <DialogContent>
                                <TextField margin="dense" select label="Status" name="status" value={formData.status || ''} onChange={handleChange} fullWidth>
                                    {["Pending", "In Progress", "Completed"].map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField margin="dense" select label="SEO Focus" name="seoFocus" value={formData.seoFocus || ''} onChange={handleChange} fullWidth>
                                    {["On-Page SEO", "Backlinks"].map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField margin="dense" label="Completed Tasks" name="completedTasks" value={formData.completedTasks} onChange={handleChange} type="number" fullWidth />
                                <TextField margin="dense" label="Completed Percentage" name="completionStatus" value={formData.completionStatus} onChange={handleChange} type="number" fullWidth />
                                <TextField margin="dense" label="Word Count" name="wordCount" InputLabelProps={{ shrink: true }} value={formData.wordCount} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Key Words" name="keywords" InputLabelProps={{ shrink: true }} value={formData.keywords} onChange={handleChange} fullWidth />
                                <Input
                                    type="file"
                                    name="fileUpload"
                                    accept=".jpg,.jpeg,.png,.webp,.avif,"
                                    onChange={(e) => handleFileChange(e, UserId)}
                                />
                                {selectedFiles[UserId] && <span>{selectedFiles[UserId].name}</span>}
                            </DialogContent>
                        </>
                    )}

                    {serviceTeamType === "Camera Man" && (
                        <>
                            <>
                                <DialogContent>
                                    <TextField margin="dense" label="Completion Status" name="completionStatus" InputLabelProps={{ shrink: true }} value={formData.completionStatus} onChange={handleChange} fullWidth />
                                    <Input
                                        type="file"
                                        name="rawFootageUpload"
                                        accept=".jpg,.jpeg,.png,.webp,.avif,"
                                        onChange={(e) => handleFileChange(e, UserId)}
                                    />
                                    {selectedFiles[UserId] && <span>{selectedFiles[UserId].name}</span>}
                                </DialogContent>
                            </>
                        </>
                    )}

                    {serviceTeamType === "Video Editing" && (
                        <>
                            <DialogContent>
                                <TextField margin="dense" label="Editing Software Used" name="editingSoftwareUsed" InputLabelProps={{ shrink: true }} value={formData.editingSoftwareUsed} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Editing Progress" name="editingProgress" InputLabelProps={{ shrink: true }} value={formData.editingProgress} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Comments" name="comments" InputLabelProps={{ shrink: true }} value={formData.comments} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Team Communication Notes" name="teamCommunicationNotes" InputLabelProps={{ shrink: true }} value={formData.teamCommunicationNotes} onChange={handleChange} fullWidth />
                                <Input
                                    type="file"
                                    name="rawFootageUpload"
                                    accept=".jpg,.jpeg,.png,.webp,.avif,"
                                    onChange={(e) => handleFileChange(e, UserId)}
                                />
                                {selectedFiles[UserId] && <span>{selectedFiles[UserId].name}</span>}
                            </DialogContent>
                        </>
                    )}

                    {serviceTeamType === "Social Media" && (
                        <>
                            <DialogContent>
                                <TextField margin="dense" select label="Post Status" name="postStatus" value={formData.postStatus || ''} onChange={handleChange} fullWidth>
                                    {["Scheduled", "Posted", "Draft", "Pending Approval"].map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField margin="dense" label="Content Topic" name="contentTopic" InputLabelProps={{ shrink: true }} value={formData.contentTopic} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Comments" name="comments" InputLabelProps={{ shrink: true }} value={formData.comments} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Scheduled Date Time" name="scheduledDateTime" type="datetime-local" InputLabelProps={{ shrink: true }} value={formData.scheduledDateTime} onChange={handleChange} fullWidth />
                                <TextField margin="dense" label="Deadline" name="deadline" type='date' InputLabelProps={{ shrink: true }} value={formData.deadline} onChange={handleChange} fullWidth />
                            </DialogContent>
                        </>
                    )}

                    <DialogActions>
                        <Button onClick={() => setFormOpen(false)} color="secondary">Cancel</Button>
                        <Button onClick={postDailyUpdates} color="primary">Update</Button>
                    </DialogActions>
                </Dialog>

            </Container>
        </>
    )
}

export default OnGoingTasks